import { render, staticRenderFns } from "./FileAlt.vue?vue&type=template&id=2875bff5&"
import script from "./FileAlt.vue?vue&type=script&lang=js&"
export * from "./FileAlt.vue?vue&type=script&lang=js&"
import style0 from "./FileAlt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports